import React from 'react'

const Loader = () => {
    return (
        <div className="loader">
            <i className="fas fa-spinner fa-4x fa-spin" />
        </div>
    )
}

export default Loader
